import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { useContext } from 'react';
import uuid from 'uuid/v4';
import { SearchDialogAnalyticsContext } from '../analytics';
var SearchSessionContext = /*#__PURE__*/React.createContext({
  searchSessionId: undefined
});
var SearchSessionProviderError = /*#__PURE__*/function (_Error) {
  function SearchSessionProviderError() {
    _classCallCheck(this, SearchSessionProviderError);
    return _callSuper(this, SearchSessionProviderError, ['Could not find any SearchSessionProvider, make sure there is a SearchSessionProvider further up the tree']);
  }
  _inherits(SearchSessionProviderError, _Error);
  return _createClass(SearchSessionProviderError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Wraps a component and provides the component with a searchSessionId.
 * The searchSessionId will either be retrieved from the closest SearchSessionProvider or a new one
 * will be generated with the wrapped component is mounted.
 */
export function injectSearchSession(Component) {
  var WrapperComponent = function WrapperComponent(props) {
    return /*#__PURE__*/React.createElement(SearchSessionContext.Consumer, null, function (_ref) {
      var searchSessionId = _ref.searchSessionId;
      if (!searchSessionId) {
        throw new SearchSessionProviderError();
      }
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        searchSessionId: searchSessionId
      }));
    });
  };
  return WrapperComponent;
}
/**
 * A search session context provider.
 * This provides all children wrapped with injectSearchSession with the same search session id.
 * Noted a new search session id is generated if and only if this component is mounted.
 */
export var SearchSessionProvider = /*#__PURE__*/function (_React$Component) {
  function SearchSessionProvider() {
    var _this;
    _classCallCheck(this, SearchSessionProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SearchSessionProvider, [].concat(args));
    _defineProperty(_this, "state", {
      sessionKey: _this.props.sessionKey,
      searchSessionId: uuid()
    });
    return _this;
  }
  _inherits(SearchSessionProvider, _React$Component);
  return _createClass(SearchSessionProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var searchSessionId = this.state.searchSessionId;
      return /*#__PURE__*/React.createElement(SearchSessionContext.Provider, {
        value: {
          searchSessionId: searchSessionId
        }
      }, /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
        analyticContext: {
          searchSessionId: searchSessionId
        },
        nonPrivacySafeAnalyticContext: {}
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Reset the searchSessionId only when the dialog is expanded
      return {
        sessionKey: props.sessionKey,
        searchSessionId: props.sessionKey !== state.sessionKey && props.sessionKey !== 'ssid_provider_false' ? uuid() : state.searchSessionId
      };
    }
  }]);
}(React.Component);
export function useSearchSessionId() {
  var _useContext = useContext(SearchSessionContext),
    searchSessionId = _useContext.searchSessionId;
  if (searchSessionId) {
    return searchSessionId;
  }
  throw new SearchSessionProviderError();
}